
import React from 'react';
import { BasePopup } from './BasePopup';
import { MultipleFileUploadComponent } from 'components/form/MultipleFileUpload';

interface EvidencePopupProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (e: React.FormEvent) => void;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onFileChange: (file: File[]) => void;

  formData: any;
  pdfFile: File[] | null;
  loading: boolean;
  error: string | null;
  isEditMode?: boolean;
  existingData?: any;
}

export const EvidencePopup: React.FC<EvidencePopupProps> = ({
  isOpen,
  onClose,
  onSubmit,
  onInputChange,
  onFileChange,
 
  formData,
  pdfFile,
  loading,
  error,
  isEditMode = false,
  existingData
}) => {
  return (
    <BasePopup
      isOpen={isOpen}
      onClose={onClose}
      title={isEditMode ? "Edit Evidence" : "Add Evidence"}
      description={isEditMode ? "Edit evidence information" : "Add evidence information"}
      error={error}
    >
      <form onSubmit={onSubmit}>
        <div className="flex flex-col">
          <label className="referral-popup-label">Evidence Type</label>
          <input
            type="text"
            className="referral-form-field"
            onChange={onInputChange}
            name="evidence_type"
            placeholder="Evidence Type"
            value={formData.evidence_type}
          />
        </div>
        <div className="flex flex-col">
          <label className="referral-popup-label">Date</label>
          <input
            className="referral-form-field"
            onChange={onInputChange}
            name="date"
            placeholder="Date"
            type="date"
            value={formData.date}
          />
        </div>
        <div className="flex flex-col">
          <label className="referral-popup-label">Description</label>
          <textarea
            onChange={onInputChange}
            name="description"
            placeholder="Evidence Description"
            className="referral-form-field h-24"
            value={formData.description}
          />
        </div>
        
        <MultipleFileUploadComponent
        uploadedFiles={pdfFile as File[]}
        onFilesChange={onFileChange}
        
        />

        <button
          type="submit"
          disabled={loading}
          className={`mt-6 mb-4 referral-form-button ${
            loading ? "opacity-50 cursor-not-allowed" : ""
          }`}
        >
          {loading ? "Processing..." : isEditMode ? "Update Evidence" : "Add Evidence"}
        </button>
      </form>
    </BasePopup>
  );
};